import { footerColumns } from "@/mocks/homeData";

export default function SiteFooter() {
  return (
    <footer id="footer" className="bg-primary-950 text-background-100">
      <div className="mx-auto max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-end gap-3">
              <span className="font-heading text-2xl font-black text-background-50 md:text-3xl">黑料社网</span>
              <span className="mb-1 text-[10px] uppercase tracking-[0.3em] text-primary-300">
                the gossip daily
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-100/75">
              黑料社网专注今日黑料、热门爆料与头条新料的快速聚合。我们把散落在各处的讨论整理成清晰的阅读线索，让吃瓜群众不错过每一条值得关注的瓜。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href="#buzz"
                className="flex h-9 w-9 items-center justify-center rounded-full border border-background-50/20 text-background-100 transition-colors hover:border-accent-400 hover:text-accent-400"
                aria-label="微博"
              >
                <i className="ri-weibo-line" />
              </a>
              <a
                href="#buzz"
                className="flex h-9 w-9 items-center justify-center rounded-full border border-background-50/20 text-background-100 transition-colors hover:border-accent-400 hover:text-accent-400"
                aria-label="公众号"
              >
                <i className="ri-wechat-line" />
              </a>
              <a
                href="#buzz"
                className="flex h-9 w-9 items-center justify-center rounded-full border border-background-50/20 text-background-100 transition-colors hover:border-accent-400 hover:text-accent-400"
                aria-label="视频号"
              >
                <i className="ri-play-circle-line" />
              </a>
              <a
                href="#buzz"
                className="flex h-9 w-9 items-center justify-center rounded-full border border-background-50/20 text-background-100 transition-colors hover:border-accent-400 hover:text-accent-400"
                aria-label="投稿"
              >
                <i className="ri-send-plane-line" />
              </a>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 md:col-span-7">
            {footerColumns.map((column) => (
              <div key={column.title}>
                <h4 className="font-heading text-sm font-bold text-background-50">{column.title}</h4>
                <ul className="mt-4 flex flex-col gap-3">
                  {column.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        className="text-sm text-background-100/70 transition-colors hover:text-accent-400"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-50/15 pt-6 text-xs text-background-100/60 md:flex-row md:items-center md:justify-between">
          <span>© 2026 黑料社网 · 内容均为网络公开信息整理，仅供娱乐参考</span>
          <span className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-refresh-line" />
              今日已更新 46 条
            </span>
            <span className="hidden h-3 w-px bg-background-50/20 sm:block" />
            <span className="hidden sm:block">理性吃瓜 · 不传谣 · 不站队</span>
          </span>
        </div>
      </div>
    </footer>
  );
}